import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export default function Loader() {
    return (_jsx("div", { className: "d-flex justify-content-center align-items-center", style: { minHeight: '10rem' }, children: _jsxs("div", { className: "lds-roller", children: [_jsx("div", {}), _jsx("div", {}), _jsx("div", {}), _jsx("div", {}), _jsx("div", {}), _jsx("div", {}), _jsx("div", {}), _jsx("div", {})] }) }));
}
